import { APPOINTMENTS } from 'constants/routes';
import { serviceRoles } from 'config/access';
import { checkAccess } from 'helpers/auth';
import AppointmentsPage from './container/AppointmentsPage';

export default function getSettingsRoute(userAuth) {
  const { account, reports } = serviceRoles;
  const requireAuth = {
    [account.name]: [
      account.roles.superadmin,
    ],
    [reports.name]: [
      reports.roles.reporter,
    ],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: APPOINTMENTS,
    withSidebar: true,
    withAppBar: true,
    component: AppointmentsPage,
  };
}
